
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.514 18H1.689c-.427 0-.813-.1-1.144-.398C.172 17.26 0 16.84 0 16.329c.02-1.53.483-2.909 1.393-4.118.723-.967 1.689-1.529 2.847-1.742.917-.164 1.799-.014 2.681.263a5.192 5.192 0 003.171 0c.642-.2 1.29-.356 1.958-.327 1.496.057 2.716.668 3.633 1.899a6.57 6.57 0 011.22 2.866c.07.426.097.86.097 1.287a1.558 1.558 0 01-1.379 1.522c-.117.014-.241.014-.358.014C13.015 18 10.76 18 8.513 18zM3.826 4.829C3.846 2.183 5.86.014 8.514 0c2.585-.014 4.688 2.183 4.674 4.836-.014 2.624-2.027 4.808-4.695 4.815-2.578.014-4.667-2.17-4.667-4.822z","fill":"#B6B6B6"}})])
          )
        }
      }
    